import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Platformfeature() {
  return (
    <section className="platform_feature p-100 text_onsite">
      <Container>
        <Row>
          <Col
            xs={12}
            md={6}
            lg={5}
            xl={5}
            xxl={5}
            className="text-center resp_order"
          >
            <div className="platform_img_onsite">
              <StaticImage
                src="../../../images/case-studies/onsite/challenges.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={655}
                height={698}
              />
            </div>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={5}
            xl={5}
            xxl={5}
            className="offset-xl-1 offset-lg-1 my-auto"
          >
            <h2>
              Project <span>Challenges</span>
            </h2>
            <p>
              Apart from some controllable difficulties, the major challenge
              that we faced during the development of OnSite Social was the
              incorporation of latitude and longitude management within a
              300-foot radius. Because it was the core aspect of the app,
              ensuring accurate location-based tracking while maintaining user
              privacy and system efficiency was a complex task.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Platformfeature;
